// Caprasimo for the panel title. @font-face has to live in the document,
// not the shadow root, so a small <style> goes into <head>. The woff2 is
// served next to loader.js (public/fonts, copied at build time).

const LATIN_RANGE =
  'U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD'

export function ensureCaprasimo(assetBase: string) {
  if (document.head.querySelector('style[data-airys-font]')) return
  const style = document.createElement('style')
  style.setAttribute('data-airys-font', 'caprasimo')
  style.textContent = `@font-face {
  font-family: 'Caprasimo';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${assetBase}fonts/caprasimo-latin-400-normal.woff2) format('woff2');
  unicode-range: ${LATIN_RANGE};
}`
  document.head.appendChild(style)
}
